/* global axios */
import ApiClient from '../ApiClient';

class BotDataSourcesAPI extends ApiClient {
  constructor() {
    super('omni/agent_bots', { accountScoped: true });
  }

  // GET /api/v1/accounts/:account_id/omni/agent_bots/:bot_id/data_sources
  getSources(botId, params = {}) {
    return axios.get(`${this.url}/${botId}/data_sources`, { params });
  }

  // GET /api/v1/accounts/:account_id/omni/agent_bots/:bot_id/data_sources/:id
  getSource(botId, sourceId) {
    return axios.get(`${this.url}/${botId}/data_sources/${sourceId}`);
  }

  // POST /api/v1/accounts/:account_id/omni/agent_bots/:bot_id/data_sources (file upload)
  createSource(botId, formData) {
    return axios.post(`${this.url}/${botId}/data_sources`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  // POST /api/v1/accounts/:account_id/omni/agent_bots/:bot_id/data_sources (API source)
  createApiSource(botId, data) {
    return axios.post(`${this.url}/${botId}/data_sources`, data);
  }

  // PATCH /api/v1/accounts/:account_id/omni/agent_bots/:bot_id/data_sources/:id
  updateApiSource(botId, sourceId, data) {
    return axios.patch(`${this.url}/${botId}/data_sources/${sourceId}`, data);
  }

  // DELETE /api/v1/accounts/:account_id/omni/agent_bots/:bot_id/data_sources/:id
  deleteSource(botId, sourceId) {
    return axios.delete(`${this.url}/${botId}/data_sources/${sourceId}`);
  }

  // POST /api/v1/accounts/:account_id/omni/agent_bots/:bot_id/data_sources/:id/start_process
  processSource(botId, sourceId) {
    return axios.post(`${this.url}/${botId}/data_sources/${sourceId}/start_process`);
  }

  // POST /api/v1/accounts/:account_id/omni/agent_bots/:bot_id/data_sources/:id/reprocess
  reprocessSource(botId, sourceId) {
    return axios.post(`${this.url}/${botId}/data_sources/${sourceId}/reprocess`);
  }

  // POST /api/v1/accounts/:account_id/omni/agent_bots/:bot_id/data_sources/:id/sync
  syncSource(botId, sourceId) {
    return axios.post(`${this.url}/${botId}/data_sources/${sourceId}/sync`);
  }

  // GET /api/v1/accounts/:account_id/omni/agent_bots/:bot_id/data_sources/collections
  getCollections(botId) {
    return axios.get(`${this.url}/${botId}/data_sources/collections`);
  }

  // POST /api/v1/accounts/:account_id/omni/agent_bots/:bot_id/data_sources/test_api
  testApi(botId, data) {
    return axios.post(`${this.url}/${botId}/data_sources/test_api`, data);
  }

  // POST /api/v1/accounts/:account_id/omni/agent_bots/:bot_id/data_sources/generate_extraction
  generateExtraction(botId, data) {
    return axios.post(`${this.url}/${botId}/data_sources/generate_extraction`, data);
  }

  // POST /api/v1/accounts/:account_id/omni/agent_bots/:bot_id/data_sources/preview_extraction
  previewExtraction(botId, data) {
    return axios.post(`${this.url}/${botId}/data_sources/preview_extraction`, data);
  }

  // --- Data Entries ---

  // GET /api/v1/accounts/:account_id/omni/agent_bots/:bot_id/data_entries
  getEntries(botId, params = {}) {
    return axios.get(`${this.url}/${botId}/data_entries`, { params });
  }

  // GET /api/v1/accounts/:account_id/omni/agent_bots/:bot_id/data_entries/:id
  getEntry(botId, entryId) {
    return axios.get(`${this.url}/${botId}/data_entries/${entryId}`);
  }

  // POST /api/v1/accounts/:account_id/omni/agent_bots/:bot_id/data_entries
  createEntry(botId, data) {
    return axios.post(`${this.url}/${botId}/data_entries`, data);
  }

  // PATCH /api/v1/accounts/:account_id/omni/agent_bots/:bot_id/data_entries/:id
  updateEntry(botId, entryId, data) {
    return axios.patch(`${this.url}/${botId}/data_entries/${entryId}`, data);
  }

  // DELETE /api/v1/accounts/:account_id/omni/agent_bots/:bot_id/data_entries/:id
  deleteEntry(botId, entryId) {
    return axios.delete(`${this.url}/${botId}/data_entries/${entryId}`);
  }

  // POST /api/v1/accounts/:account_id/omni/agent_bots/:bot_id/data_entries/:id/regenerate_embedding
  regenerateEntryEmbedding(botId, entryId) {
    return axios.post(`${this.url}/${botId}/data_entries/${entryId}/regenerate_embedding`);
  }

  // POST /api/v1/accounts/:account_id/omni/agent_bots/:bot_id/data_entries/search
  searchEntries(botId, query, params = {}) {
    return axios.post(`${this.url}/${botId}/data_entries/search`, { query, ...params });
  }

  // GET /api/v1/accounts/:account_id/omni/agent_bots/:bot_id/data_entries/collections
  getEntryCollections(botId) {
    return axios.get(`${this.url}/${botId}/data_entries/collections`);
  }

  // GET /api/v1/accounts/:account_id/omni/agent_bots/:bot_id/data_entries/stats
  getEntryStats(botId) {
    return axios.get(`${this.url}/${botId}/data_entries/stats`);
  }

  // DELETE /api/v1/accounts/:account_id/omni/agent_bots/:bot_id/data_entries/bulk_destroy
  // params: { ids: [1, 2, 3] } or { collection: 'my-collection' }
  bulkDeleteEntries(botId, params) {
    return axios.delete(`${this.url}/${botId}/data_entries/bulk_destroy`, { params });
  }
}

export default new BotDataSourcesAPI();

